import { camelize, wrapInArray } from './helpers';
const pattern = {
    styleList: /;(?![^(]*\))/g,
    styleProp: /:(.*)/
};
function parseStyle(style) {
    const styleMap = {};
    for (const s of style.split(pattern.styleList)) {
        let [key, val] = s.split(pattern.styleProp);
        key = key.trim();
        if (!key) {
            continue;
        }
        if (typeof val === 'string') {
            val = val.trim();
        }
        styleMap[camelize(key)] = val;
    }
    return styleMap;
}
export default function mergeData() {
    const mergeTarget = {};
    let i = arguments.length;
    let prop;
    while (i--) {
        for (prop of Object.keys(arguments[i])) {
            switch (prop) {
                case 'class':
                case 'directives':
                    if (arguments[i][prop]) {
                        mergeTarget[prop] = mergeClasses(mergeTarget[prop], arguments[i][prop]);
                    }
                    break;
                case 'style':
                    if (arguments[i][prop]) {
                        mergeTarget[prop] = mergeStyles(mergeTarget[prop], arguments[i][prop]);
                    }
                    break;
                case 'staticClass':
                    if (!arguments[i][prop]) {
                        break;
                    }
                    if (mergeTarget[prop] === undefined) {
                        mergeTarget[prop] = '';
                    }
                    if (mergeTarget[prop]) {
                        mergeTarget[prop] += ' ';
                    }
                    mergeTarget[prop] += arguments[i][prop].trim();
                    break;
                case 'on':
                case 'nativeOn':
                    if (arguments[i][prop]) {
                        mergeTarget[prop] = mergeListeners(mergeTarget[prop], arguments[i][prop]);
                    }
                    break;
                case 'attrs':
                case 'props':
                case 'domProps':
                case 'scopedSlots':
                case 'staticStyle':
                case 'hook':
                case 'transition':
                    if (!arguments[i][prop]) {
                        break;
                    }
                    if (!mergeTarget[prop]) {
                        mergeTarget[prop] = {};
                    }
                    mergeTarget[prop] = { ...arguments[i][prop],
                        ...mergeTarget[prop]
                    };
                    break;
                default:
                    if (!mergeTarget[prop]) {
                        mergeTarget[prop] = arguments[i][prop];
                    }
            }
        }
    }
    return mergeTarget;
}
export function mergeStyles(target, source) {
    if (!target)
        return source;
    if (!source)
        return target;
    target = wrapInArray(typeof target === 'string' ? parseStyle(target) : target);
    return target.concat(typeof source === 'string' ? parseStyle(source) : source);
}
export function mergeClasses(target, source) {
    if (!source)
        return target;
    if (!target)
        return source;
    return target ? wrapInArray(target).concat(source) : source;
}
export function mergeListeners(...args) {
    if (!args[0])
        return args[1];
    if (!args[1])
        return args[0];
    const dest = {};
    for (let i = 2; i--;) {
        const arg = args[i];
        for (const event in arg) {
            if (!arg[event])
                continue;
            if (dest[event]) {
                dest[event] = [].concat(arg[event], dest[event]);
            }
            else {
                dest[event] = arg[event];
            }
        }
    }
    return dest;
}
